import React, { useState } from "react";
import PropTypes from "prop-types";
import "./styles.scss";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const TextBox = ({ data, onChange }) => {
  // Validate the status to ensure it has a valid value
  const validStatus = ["default", "valid", "error", "disabled"];
  const status = validStatus.includes(data.status) ? data.status : "default";

  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <>
      {!data.isLoading && (
        <div
          className={`input-wrapper ${data.layerStyles} ${
            data.style
          } ${status} ${data.disabled ? "disabled" : ""}`}
        >
          <form autoComplete="off" style={{ width: "100%" }}>
            <label className="input-label">{data.label}</label>
            <input
              id={data.key}
              type={data.type || "text"}
              placeholder={data.placeholder}
              value={data.value}
              {...data.elementConfig}
              {...(data.isPassword && {
                ...(data.elementConfig.type = showPassword
                  ? "text"
                  : "password"),
              })}
              className={`input-field ${status} ${data.size}`}
              disabled={data.disabled}
              onChange={!data.disabled ? onChange : null}
              style={{
                borderColor: status === "error" ? "red" : "initial",
              }}
            />
          </form>
          {data.isPassword && (
            <div
              onClick={togglePasswordVisibility}
              className={`password-toggle-icon ${data.value ? "active" : " "}`}
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          )}
          {!data.isValid && data.touched && (
            <div className="error-message">
              {data.invalidReason || "Invalid Value"}
            </div>
          )}
        </div>
      )}

      {data.isLoading && <div className="loading-input">Loading...</div>}
    </>
  );
};

TextBox.propTypes = {
  data: PropTypes.shape({
    key: PropTypes.string.isRequired,
    layerStyles: PropTypes.string,
    style: PropTypes.string,
    status: PropTypes.oneOf(["default", "valid", "error", "disabled"]),
    disabled: PropTypes.bool,
    label: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string,
    invalidReason: PropTypes.string,
    type: PropTypes.string,
    size: PropTypes.string,
    isLoading: PropTypes.bool,
    isValid: PropTypes.bool,
    touched: PropTypes.bool,
  }),
  onChange: PropTypes.func.isRequired,
};

TextBox.defaultProps = {
  data: {
    status: "default",
    disabled: false,
    type: "text",
    size: "md",
    isValid: true,
    touched: false,
  },
};

export default TextBox;
